import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, ChevronDown } from "lucide-react";
import "../styles/AdminSidebar.css";

export default function AdminSidebar({ menuOpen = false, setMenuOpen = () => {} }) {
  const location = useLocation();
  const [hoverMenu, setHoverMenu] = useState(null);

  const navGroups = [
    {
      label: "Sales",
      children: [
        { label: "Publishing Dashboard", path: "/admin/dashboard" },
        { label: "Sales Dashboard", path: "/admin/sales" },
        { label: "Rankings", path: "/admin/rankings" },
        { label: "Orders", path: "/admin/orders" },
        { label: "Coupon Management", path: "/admin/coupons" }
      ]
    },
    {
      label: "Content",
      children: [
        { label: "Books", path: "/admin/books" },
        { label: "Blogs", path: "/admin/blogs" },
        { label: "Merch", path: "/admin/merch" },
        { label: "Images", path: "/admin/images"}
      ]
    },
    {
      label: "Marketing",
      children: [
        { label: "Publishing Queue", path: "/admin/marketing" },
        { label: "Bookstore Outreach", path: "/admin/bookstores" },
        { label: "Audiobook Reviewers", path: "/admin/audiobook-reviewers" },
        { label: "Social Posts", path: "/admin/social-posts" },
        { label: "Auto Social Post Management", path: "/admin/auto-social-posts" },
        { label: "Testimonials", path: "/admin/testimonials" }
      ]
    },
    {
      label: "Email",
      children: [
        { label: "Write Newsletter", path: "/admin/newsletter" },
        { label: "Email Templates", path: "/admin/email-templates" },
        { label: "Newsletter History", path: "/admin/newsletter-history" },
        { label: "Email History", path: "/admin/email-history" },
        { label: "Subscribers", path: "/admin/subscribers" }
      ]
    },
    {
      label: "Settings",
      children: [
        { label: "Settings", path: "/admin/settings" },
        { label: "Marketplaces", path: "/admin/marketplaces" },
        { label: "Cron Jobs", path: "/admin/cron-jobs" }
      ]
    }
  ];

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const isGroupActive = (group) =>
    group.children.some((c) => isActive(c.path));

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        className="admin-hamburger"
        aria-label="Toggle admin navigation"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <Menu size={22} />
      </button>

      {/* Sidebar Navigation */}
      <nav className={menuOpen ? "admin-subnav mobile open" : "admin-subnav"}>
        <ul className="admin-nav-list">

          {navGroups.map((group, index) => (
            <li
              key={index}
              className={
                isGroupActive(group)
                  ? "admin-nav-parent active"
                  : "admin-nav-parent"
              }
              onMouseEnter={() => { if (window.innerWidth > 900) setHoverMenu(group.label); }}
              onMouseLeave={() => { if (window.innerWidth > 900) setHoverMenu(null); }}
              onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setHoverMenu(null); }}
            >
              <button type="button" className="admin-nav-title" aria-expanded={hoverMenu === group.label} aria-controls={`admin-menu-${index}`} onClick={() => setHoverMenu(value => window.innerWidth <= 900 && value === group.label ? null : group.label)} onKeyDown={event => { if (event.key === "Escape") setHoverMenu(null); }}>{group.label} <ChevronDown size={15} /></button>

              <ul
                id={`admin-menu-${index}`}
                className={
                  hoverMenu === group.label
                    ? "admin-submenu show"
                    : "admin-submenu"
                }
              >
                {group.children.map((child, i) => (
                  <li key={i}>
                    <Link
                      to={child.path}
                      className={
                        isActive(child.path)
                          ? "admin-submenu-link active"
                          : "admin-submenu-link"
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      {child.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}

        </ul>
      </nav>
    </>
  );
}
